/* Wit ‚Äî Atelier modern: header, mega-menu, mobiel menu, popup, kaarten, weergave */
(function () {
  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }

  ready(function () {
    var header = document.querySelector('.r-header');

    /* Header wordt ivoor na de hero (alleen als hij over een beeld staat) */
    if (header && header.classList.contains('r-header--overlay')) {
      var solid = function () { header.classList.toggle('is-solid', window.scrollY > window.innerHeight * 0.6); };
      window.addEventListener('scroll', solid, { passive: true });
      solid();
    }

    /* Mega-menu: openen bij hover/focus */
    if (header) {
      var openWrap = null, t;
      var close = function () { if (openWrap) openWrap.classList.remove('is-open'); openWrap = null; header.classList.remove('dd-open'); };
      header.querySelectorAll('.r-dd').forEach(function (wrap) {
        if (!wrap.querySelector('.r-dd-panel')) return;
        var open = function () { clearTimeout(t); if (openWrap && openWrap !== wrap) openWrap.classList.remove('is-open'); openWrap = wrap; wrap.classList.add('is-open'); header.classList.add('dd-open'); };
        wrap.addEventListener('mouseenter', open);
        wrap.addEventListener('focusin', open);
        wrap.addEventListener('mouseleave', function () { t = setTimeout(function () { if (openWrap === wrap) close(); }, 120); });
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    }

    /* Mobiel menu */
    var mm = document.getElementById('r-mm');
    if (mm) {
      var setMm = function (on) { mm.classList.toggle('is-open', on); mm.setAttribute('aria-hidden', on ? 'false' : 'true'); document.documentElement.style.overflow = on ? 'hidden' : ''; };
      document.querySelectorAll('[data-mm-open]').forEach(function (b) { b.addEventListener('click', function () { setMm(true); }); });
      mm.querySelectorAll('[data-mm-close]').forEach(function (b) { b.addEventListener('click', function () { setMm(false); }); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMm(false); });
    }

    /* Zaterdag-melding ‚Äî √©√©n keer per sessie */
    var notice = document.getElementById('r-notice');
    if (notice) {
      var KEY = 'wit-busy-notice-seen';
      var hide = function () { notice.classList.remove('is-open'); setTimeout(function () { notice.hidden = true; }, 500); try { sessionStorage.setItem(KEY, '1'); } catch (e) {} };
      var seen = false; try { seen = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
      var delay = parseInt(notice.getAttribute('data-delay') || '1100', 10);
      if (!seen || notice.hasAttribute('data-design-mode')) setTimeout(function () {
        notice.hidden = false;
        requestAnimationFrame(function () { requestAnimationFrame(function () { notice.classList.add('is-open'); }); });
      }, delay);
      notice.querySelectorAll('[data-notice-close]').forEach(function (b) { b.addEventListener('click', hide); });
      notice.addEventListener('click', function (e) { if (e.target === notice) hide(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !notice.hidden) hide(); });
    }

    /* Collectie: groot/klein-weergave */
    var grid = document.getElementById('s-grid');
    document.querySelectorAll('.s-view').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!grid) return;
        grid.style.setProperty('--cols', b.getAttribute('data-cols'));
        document.querySelectorAll('.s-view').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      });
    });
  });

  /* Productkaart op mobiel: stipjes volgen het swipen */
  document.addEventListener('scroll', function (e) {
    var tr = e.target; if (!tr.classList || !tr.classList.contains('r-prod-track')) return;
    var i = Math.round(tr.scrollLeft / tr.clientWidth);
    tr.parentNode.querySelectorAll('.r-prod-dots span').forEach(function (d, n) { d.classList.toggle('on', n === i); });
  }, true);
})();

// Reviews: stipjes onder de swipe-rij op mobiel
(function () {
  function init() {
    document.querySelectorAll('.r-reviews-grid').forEach(function (g) {
      if (g.nextElementSibling && g.nextElementSibling.classList.contains('r-reviews-dots')) return;
      var n = g.children.length; if (n < 2) return;
      var d = document.createElement('div'); d.className = 'r-reviews-dots'; d.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < n; i++) d.appendChild(document.createElement('span'));
      d.firstChild.classList.add('on');
      g.parentNode.insertBefore(d, g.nextSibling);
      g.addEventListener('scroll', function () {
        var w = g.children[0].getBoundingClientRect().width + 20;
        var k = Math.min(n - 1, Math.round(g.scrollLeft / w));
        [].forEach.call(d.children, function (s, j) { s.classList.toggle('on', j === k); });
      }, { passive: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Theme-editor: dropdown openen wanneer je een Dropdown-beeld of -tekstkolom selecteert */
(function () {
  function closeAll() {
    document.querySelectorAll('.r-dd.is-open').forEach(function (w) { w.classList.remove('is-open'); });
    var h = document.querySelector('.r-header'); if (h) h.classList.remove('dd-open');
  }
  document.addEventListener('shopify:block:select', function (e) {
    var wrap = e.target && e.target.closest ? e.target.closest('.r-dd') : null;
    closeAll();
    if (wrap) { wrap.classList.add('is-open'); var h = document.querySelector('.r-header'); if (h) h.classList.add('dd-open'); }
  });
  document.addEventListener('shopify:block:deselect', closeAll);
})();

